import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { Reveal, Eyebrow, EASE } from "@/components/Reveal";

const Faq = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="border-t border-bone/10 bg-dark py-20 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-16">
        <Reveal>
          <Eyebrow>{t.faq.eyebrow}</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 max-w-xl font-display text-4xl font-medium tracking-tight sm:text-5xl">{t.faq.title}</h2>
        </Reveal>

        <div className="mx-auto mt-12 max-w-4xl border-t border-bone/10 lg:mx-0">
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-bone/10">
                <button
                  data-testid={`faq-toggle-${i + 1}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                >
                  <span className="flex items-baseline gap-5">
                    <span className="font-mono text-xs text-gold">[{String(i + 1).padStart(2, "0")}]</span>
                    <span
                      className={`font-display text-lg font-medium tracking-tight transition-colors duration-300 sm:text-xl ${
                        isOpen ? "text-gold" : "group-hover:text-bone"
                      }`}
                    >
                      {item.q}
                    </span>
                  </span>
                  <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3, ease: EASE }} className="shrink-0">
                    <Plus size={18} className="text-gold" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: EASE }}
                      className="overflow-hidden"
                    >
                      <p className="max-w-3xl pb-7 text-sm leading-relaxed text-inkmuted sm:pl-10" data-testid={`faq-answer-${i + 1}`}>
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
